<template>
	<div class="p-10">
		<div class="flex justify-between">
			<h1>{{ $t('documents') }}</h1>
			<div class="ml-auto">
				<template v-if="invoicesRightPanelCollapsed">
					<el-button size="mini" type="primary" @click="toggleRightPanel(false)">
						<div>
							<div style="float: right;">
								<svg class="hamburger" style="transform: rotate(180deg);" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="17" height="17">
									<path
										style="fill: white; verical-align: middle !important"
										d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
									/>
								</svg>
							</div>
						</div>
					</el-button>
				</template>
				<template v-else>
					<el-button size="mini" type="primary" @click="toggleRightPanel(true)">
						<div>
							<div style="float: right;">
								<svg class="hamburger" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="17" height="17">
									<path
										style="fill: white; verical-align: middle !important"
										d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
									/>
								</svg>
							</div>
						</div>
					</el-button>
				</template>
			</div>
		</div>
		<el-row :gutter="5">
			<el-col :span="rightPanelLayoutVariables.mainPanelWidth">
				<el-card class="invoices-card">
					<invoice-table
						view="invoices"
						:show-filters="true"
						:props-sort.sync="invoicesSort"
						recipient=""
						@highlightedChange="handleHighlightedChange">
					</invoice-table>
				</el-card>
			</el-col>
			<el-col :span="rightPanelLayoutVariables.rightPanelWidth">
				<div v-if="quickViewSelection !== null">
					<el-card class="box-card">
						<div slot="header" class="clearfix disp-flex">
							<div class="w-50 mt-5">
								<el-tag class="mr-10" size="mini" :type="quickViewSelection.status | risoltoStatusFilter">
									{{ $translate.invoice_status(quickViewSelection.status) }}
								</el-tag>
								<span>
									{{ quickViewSelection.document_number }}
								</span>
							</div>
							<div class="w-50 text-right">
								<el-button size="mini" type="primary" @click="onViewDetail(quickViewSelection.reference, $event)">{{ $t('viewDetail') }}</el-button>
							</div>
						</div>
						<div v-if="currentInvoice?.recipient && currentInvoice?.legal_entity">
							<actions-notes
								:recipient="currentInvoice.recipient"
								:legal-entity="currentInvoice.legal_entity"
							></actions-notes>
						</div>
					</el-card>
				</div>
				<div v-else>
					<el-card>
						{{ $t('quickViewNotice', { value: $t('anInvoice') }) }}
					</el-card>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import ActionsNotes from '@/components/_ActionsNotes/index';
import { mapGetters } from 'vuex';
import Logging from '@/logging';

export default {
	name: 'Invoices',
	components: {
		ActionsNotes
	},
	data() {
		return {
			quickViewSelection: null,
			currentInvoice: null,
			rightPanelLayoutVariables: {
				mainPanelWidth: 17,
				rightPanelWidth: 7
			},
			invoicesSort: { issue_date: 'desc_nulls_last' }
		};
	},
	computed: {
		...mapGetters(['selectedParticipantStore', 'selectedInvoices', 'invoicesRightPanelCollapsed'])
	},
	watch: {
		invoicesRightPanelCollapsed() {
			this.evaluateLayout();
		}
	},
	created() {
		this.evaluateLayout();
	},
	methods: {
		handleHighlightedChange(val) {
			Logging.log('handleHighlightedChange: ', val);
			if (val === null) {
				this.$store.commit('risolto/SET_SELECTED_INVOICES', []);
				this.quickViewSelection = null;
				this.currentInvoice = null;
			} else {
				this.$store.commit('risolto/SET_SELECTED_INVOICES', [val]);
				this.$store.commit('risolto/SET_NEW_NOTE_TYPE', 'single-invoice');
				this.quickViewSelection = val;
				this.currentInvoice = val;
			}
		},
		onViewDetail(id, e) {
			this.$router.push({ name: 'invoice-detail', params: { reference: id, participant: this.selectedParticipantStore } });
		},
		handleClick(command) {
			switch (command) {
				case 'export':
					alert('[IN DEVELOPMENT]');
					break;
				default:
					break;
			}
		},
		toggleRightPanel(value) {
			this.$store.commit('invoices/SET_RIGHT_PANEL_COLLAPSED', value);
		},
		evaluateLayout() {
			if (this.invoicesRightPanelCollapsed) {
				this.rightPanelLayoutVariables.mainPanelWidth = 24;
				this.rightPanelLayoutVariables.rightPanelWidth = 0;
			} else {
				this.rightPanelLayoutVariables.mainPanelWidth = 17;
				this.rightPanelLayoutVariables.rightPanelWidth = 7;
			}
		}
	}
};
</script>
